import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useMemo,
} from "react";

interface HeaderHeightContextValue {
  height: number;
  setHeight: (height: number) => void;
}

const HeaderHeightContext = createContext<HeaderHeightContextValue | null>(
  null,
);

export const useHeaderHeightContext = () => {
  const context = useContext(HeaderHeightContext);
  if (!context) {
    throw new Error(
      "useHeaderHeightContext must be used within a HeaderHeightProvider",
    );
  }
  return context;
};

interface HeaderHeightProviderProps {
  children: React.ReactNode;
}

export const HeaderHeightProvider: React.FC<HeaderHeightProviderProps> = ({
  children,
}) => {
  const [height, setHeight] = useState<number>(0);

  const updateHeight = useCallback((newHeight: number) => {
    setHeight(newHeight);
  }, []);

  const value = useMemo(
    () => ({ height, setHeight: updateHeight }),
    [height, updateHeight],
  );

  return (
    <HeaderHeightContext.Provider value={value}>
      {children}
    </HeaderHeightContext.Provider>
  );
};

export default HeaderHeightProvider;
